<template>
    <div class="row operator-filter pad-top">
        <div class="col-md-12">
            <MultiSelect track-by="login" v-model="Storage.selectedOperator" :options="Storage.operators"
                         :multiple="true" :searchable="true"
                         :close-on-select="false" :clear-on-select="false" :hide-selected="false" :preserve-search="true"
                         :placeholder="$t('statistic.operators')" label="login" ref="multiselect"
                         :disabled="disabled">
                <template slot="option" scope="props">
                    <div class="option__desc">
                        <span class="option__title">
                           {{ props.option.login }} {{ !props.option.name ? null : `(${props.option.name})`}} <b v-if="Storage.developMode">({{ props.option.id }})</b>
                        </span>
                    </div>
                </template>
            </MultiSelect>
        </div>
        <div class="col-12">
            <div class="row actions">
                <div class="col-6 action">
                    <button class="btn btn-info" @click="this.reset" :disabled="disabled"><i class="fa fa-trash"></i>
                        {{ $t('filters.reset') }}
                    </button>
                </div>
                <div class="col-6 action">
                    <button class="btn btn-success" @click="this.selectAll" :disabled="disabled"><i class="fa fa-reply-all"></i>
                        {{ $t('filters.select_all') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'
  import API from '../../api/API'
  import Helper from '../../api/Helper'

  export default {
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    name: 'OperatorFilter',
    components: {
      MultiSelect
    },
    data () {
      return {
        Storage: Storage
      }
    },
    mounted () {
      this.$root.$on('country_selected', () => {
        API.getOperators(Helper.getCountryList(), Helper.getOffersList()).then(response => {
          Storage.operators = Object.keys(response.data).map(key => response.data[key])
          this.reset()
        })
      })
      this.$root.$on('filters_reset_all', () => {
        this.reset()
      })
      this.$refs.multiselect.$on('select', function () {
        this.search = ''
      })
    },
    methods: {
      limitTextMessage (count) {
        return this.$root.$t('filters.more_pre') + count + this.$root.$t('filters.more_post')
      },
      selectAll () {
        Storage.selectedOperator = Storage.operators
      },
      reset () {
        Storage.selectedOperator = []
      }
    },
    beforeDestroy () {
      this.$root.$off('country_selected')
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// OperatorFilter.vue?62be07ef